import router from './../../router'
import { store } from './../../store/store'

export function errorHandler (error) {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      store.dispatch('tryAutoLogin')
      if (store.getters.estaAutenticado) {
        router.push('/naoautorizado')
      } else {
        router.push('/login')
      }
    } else if (error.response.status === 400) {
      let errorData = error.response.data
      if (errorData.exception) {
        store.dispatch('setRequestError', errorData.message)
        router.push('/erro')
      } else {
        return errorData
      }
    } else {
      store.dispatch('setRequestError', error.response)
      router.push('/erro')
    }
  } else if (error.request) {
    store.dispatch('setRequestError', error.request)
    router.push('/erro')
  } else {
    console.log(error.message)
  }
}

// axios.get('/user/12345')
//   .catch(function (error) {
//     if (error.response) {
//       // The request was made and the server responded with a status code
//       // that falls out of the range of 2xx
//       console.log(error.response.data);
//       console.log(error.response.status);
//       console.log(error.response.headers);
//     } else if (error.request) {
//       // The request was made but no response was received
//       // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//       // http.ClientRequest in node.js
//       console.log(error.request);
//     } else {
//       // Something happened in setting up the request that triggered an Error
//       console.log('Error', error.message);
//     }
//     console.log(error.config);
//   });



// WEBPACK FOOTER //
// ./src/modulos/erro/errorHandler.js